import type { FieldName, UsageMode } from "./registerFormTypes";

export const usageModeOptions = [
  {
    value: "BUSINESS",
    label: "Şirket",
    description:
      "Takım kurmak, çalışan davet etmek ve modülleri ekipçe kullanmak için.",
  },
  {
    value: "INDIVIDUAL",
    label: "Bireysel",
    description:
      "Platformu tek kullanıcı olarak hızlıca deneyip daha sonra şirket bilgilerini tamamlamak için.",
  },
];

export function getPasswordStrengthMessage(value: string): string {
  if (!value.trim())
    return "Şifreniz en az 8 karakter, 1 büyük harf, 1 küçük harf ve 1 rakam içermelidir.";

  const score = [
    value.length >= 8,
    /[A-Z]/.test(value),
    /[a-z]/.test(value),
    /[0-9]/.test(value),
    /[^A-Za-z0-9]/.test(value),
  ].filter(Boolean).length;
  if (score <= 2)
    return "Şifre zayıf görünüyor. Daha güçlü bir şifre için büyük harf, küçük harf ve rakam kullanınız.";
  if (score < 5)
    return "Şifre uygun görünüyor. Dilerseniz özel karakter ekleyerek daha da güçlendirebilirsiniz.";
  return "Şifre güçlü görünüyor.";
}

export function validateRegisterField(
  field: FieldName,
  value: string | boolean,
  usageMode: UsageMode,
  passwordValue: string
): string | null {
  if (field === "termsAccepted")
    return value
      ? null
      : "Devam etmek için kullanım koşullarını ve gizlilik politikasını onaylayınız.";
  const text = String(value || "");
  const trimmed = text.trim();
  if (field === "firstName")
    return !trimmed
      ? "Ad alanı boş bırakılamaz. Adınızı giriniz."
      : trimmed.length < 2
        ? "Ad en az 2 karakter olmalıdır. Lütfen tam adınızı giriniz."
        : null;
  if (field === "lastName")
    return !trimmed
      ? "Soyad alanı boş bırakılamaz. Soyadınızı giriniz."
      : trimmed.length < 2
        ? "Soyad en az 2 karakter olmalıdır. Lütfen tam soyadınızı giriniz."
        : null;
  if (field === "email")
    return !trimmed
      ? "E-posta adresi zorunludur. someone@example.com formatında giriniz."
      : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)
        ? "E-posta adresi geçersiz görünüyor. someone@example.com formatında giriniz."
        : null;
  if (field === "password")
    return !trimmed
      ? "Şifre alanı boş bırakılamaz. Güçlü bir şifre belirleyiniz."
      : trimmed.length < 8
        ? "Şifreniz en az 8 karakter olmalıdır. Daha güçlü bir şifre seçiniz."
        : !/[A-Z]/.test(trimmed) ||
            !/[a-z]/.test(trimmed) ||
            !/[0-9]/.test(trimmed)
          ? "Şifre güçlü görünmüyor. En az bir büyük harf, bir küçük harf ve bir rakam ekleyiniz."
          : null;
  if (field === "confirmPassword")
    return !trimmed
      ? "Şifre tekrar alanı boş bırakılamaz. Şifrenizi tekrar giriniz."
      : trimmed !== passwordValue
        ? "Şifreler eşleşmiyor. Lütfen iki alana da aynı şifreyi giriniz."
        : null;
  if (field === "organizationName" && usageMode === "BUSINESS")
    return !trimmed
      ? "Şirket adı boş bırakılamaz. Şirket adınızı giriniz."
      : trimmed.length < 2
        ? "Şirket adı çok kısa görünüyor. Resmi veya bilinen şirket adınızı giriniz."
        : null;
  return null;
}

export function normalizeRegisterError(raw?: string | null): string {
  if (!raw) return "";
  const value = raw.toLowerCase();
  if (value.includes("email already exists"))
    return "Bu e-posta sistemde zaten kayıtlı. Giriş yapabilir veya şifrenizi sıfırlayabilirsiniz.";
  if (value.includes("phone already exists"))
    return "Bu telefon numarası sistemde zaten kayıtlı görünüyor. Lütfen farklı bir numara deneyiniz.";
  if (value.includes("conflict"))
    return "Bu bilgilerle daha önce bir kayıt oluşturulmuş görünüyor. Lütfen bilgilerinizi kontrol ediniz.";
  return raw;
}
